package app.alefly.domain.model

import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

@Serializable
data class Quiz(
    val id: QuizId,
    val tenantId: TenantId,
    val status: TenantStatus,
    val slug: String,
    val title: String,
    val description: String,
    val allowedDifficulties: List<Difficulty>,
    val supportedLocales: List<String>,
    val questionCount: Int,
    val createdAt: Instant? = null,
    val updatedAt: Instant? = null,
)
